export const formatMape = (mape: number | undefined) => {
  if (mape === 0 || mape === undefined) {
    return "0%";
  }

  return `±${mape}%`;
};
